/*
  ATD - Product sale badge

  Detecta el wrapper de la galería del producto y le inyecta un badge
  con position: absolute. No modifica core de Horizon.
*/
(() => {
  if (customElements.get('atd-product-sale-badge')) return;

  // Selectores donde inyectar el badge (primero que matchee gana).
  // Priorizamos el wrapper más alto que NO tenga overflow:hidden
  // para que el badge no se vea recortado.
  const GALLERY_SELECTORS = [
    '.media-gallery__grid',
    '.product-media-container',
    '.product-media-constraint-wrapper',
    'media-gallery',
    '.product-media__drag-zoom-wrapper',
  ];

  class AtdProductSaleBadge extends HTMLElement {
    connectedCallback() {
      this.config = {
        position: this.dataset.position || 'top-right',
        bg: this.dataset.bg || '#dc2626',
        fg: this.dataset.fg || '#ffffff',
        size: this.dataset.size || 'medium',
      };

      this.#findGallery().then((gallery) => {
        if (!gallery) return;
        this.#injectBadge(gallery);
      });
    }

    async #findGallery(maxWait = 4000) {
      const find = () => {
        for (const sel of GALLERY_SELECTORS) {
          const node = document.querySelector(sel);
          if (node) return node;
        }
        return null;
      };

      const found = find();
      if (found) return found;

      return new Promise((resolve) => {
        const obs = new MutationObserver(() => {
          const node = find();
          if (node) {
            obs.disconnect();
            resolve(node);
          }
        });
        obs.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => {
          obs.disconnect();
          resolve(find());
        }, maxWait);
      });
    }

    #injectBadge(gallery) {
      // Asegurar contenedor con position relative para que el absolute funcione.
      const computed = getComputedStyle(gallery);
      if (computed.position === 'static') {
        gallery.style.position = 'relative';
      }

      // Idempotencia: si ya existe un badge inyectado, no duplicar.
      if (gallery.querySelector('[data-atd-sale-badge]')) return;

      const tpl = this.querySelector('[data-atd-sale-badge-template]');
      if (!tpl || !tpl.content.firstElementChild) return;

      const badge = tpl.content.firstElementChild.cloneNode(true);
      badge.style.setProperty('--atd-sale-badge-bg', this.config.bg);
      badge.style.setProperty('--atd-sale-badge-fg', this.config.fg);

      gallery.appendChild(badge);

      // MutationObserver: si Horizon re-renderiza la galería (cambio de variante),
      // re-inyectar el badge si se borra.
      this._obs = new MutationObserver(() => {
        if (!gallery.querySelector('[data-atd-sale-badge]')) {
          this.#injectBadge(gallery);
        }
      });
      this._obs.observe(gallery, { childList: true, subtree: false });
    }

    disconnectedCallback() {
      if (this._obs) this._obs.disconnect();
    }
  }

  customElements.define('atd-product-sale-badge', AtdProductSaleBadge);
})();
